import React from 'react';
import AdminSidebar from './AdminSidebar';
import UserSidebar from './UserSidebar';
import OemSidebar from './OemSidebar';

const MainSidebar = () => {
  // Get the user data from localStorage
  const userData = JSON.parse(localStorage.getItem('user-cred'));
  // console.log('userData: ', userData);
  const userType = userData?.user?.user_status;

  // Render the appropriate sidebar based on userType
  let sidebar = null;
  
  if (userType === '1' ) {
    sidebar = <UserSidebar />;
  } else if(userType === '2') {
    sidebar = <AdminSidebar />;
  }

  return (
    <>
      {sidebar}
    </>
  );
};

export default MainSidebar;
